export const ICONS_MAPPED = {
  'Athletics': {
    svg: {
      width: '54px',
      height: '64px',
      viewBox: '0 0 54 64',
    },
    d: 'M34.9,13.6 C31.1444637,13.6 28.1,10.5555363 28.1,6.8 C28.1,3.0444637 31.1444637,0 34.9,0 C38.6555363,0 41.7,3.0444637 41.7,6.8 C41.7,10.5555363 38.6555363,13.6 34.9,13.6 Z M50.5,17.8 C52.4,18.3 53.6,20.3 53.2,22.1 C52.6,24.6 49.6,28.9 42.5,28.9 C40.5,28.9 38.9,28.6 37.4,28 C36.6,29.8 36.1,32.4 37.4,35 C41.9,44 40.9,59.8 40.9,60.5 C40.8,62.4 39.5,63.9 37.3,63.9 C35.1,63.9 33.6,62.1 33.7,60.1 C34,56.1 33.9,44.4 31,38.3 C29.8,35.8 28,35.9 27.3,37.3 C24.7,42.8 20.4,46.5 14.2,46.5 C4.5,46.5 1.1,37.3 1,36.9 C0.3,35.1 1.3,33 3.1,32.2 C5,31.6 7,32.5 7.7,34.4 C7.8,34.6 9.6,39.2 14.1,39.2 C19.6,39.2 23.3,31.9 23.8,20.3 C20.8,20.7 18.7,23.3 17.7,29 C17.4,30.8 15.9,32.5 14,32.5 C12.1,32.5 10.5,30.8 10.5,28.8 C10.5,28.4 10.6,24.9 12.3,21.2 C14.8,15.9 19.4,13 25.4,13 C30,13 33,15.8 35.4,18 C37.9,20.4 42.7,23.1 46.1,20.4 C46.6,18.5 48.6,17.3 50.5,17.8 Z'
  }
};

export function getIcon(sport: string) {
  return (ICONS_MAPPED[sport]) ? ICONS_MAPPED[sport] : null;
}


// WEBPACK FOOTER //
// ./src/icons/icons.js